/* LM Bundel v1.7 (2 nov 2026): maat wijzigen in het paneel.
   LM Bundel v1.6 (2 nov 2026): paneel toont totale besparing t.o.v. de normale prijs.
   LM Bundel v1.5 (2 nov 2026): Shop de look-tab alleen als er een look-tag is ingesteld.
   LM Bundel v1.4 (2 nov 2026): paneel past altijd in beeld, knop altijd zichtbaar (regels scrollen), max 6 vakjes met +N.
   LM Bundel v1.3 (2 nov 2026): aanbod met basisvlak (tot 50%), kaarten met adviesprijs, -%, bundelprijs-regel en labels.
   LM Bundel v1.2 (2 nov 2026): kop met beeld, aanbod, aftelklok en knop.
   LM Bundel v1.1 (2 nov 2026): stel je eigen bundel samen. Hoort bij sections/lm-bundel.liquid
   v1.1: modus 'extra' (extra korting op de saleprijs) met teksten '% extra', percentageblokken optioneel, vaste toplijst bovenaan. */
(function () {
  'use strict';
  var root = document.querySelector('[data-lm-bundel]');
  if (!root) return;
  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-lm-bnd-config]').textContent); } catch (e) { return; }
  var $ = function (sel) { return root.querySelector(sel); };
  var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- aan/uit en periode (Amsterdam) ---------- */
  function amsOffsetMin(d) {
    try {
      var p = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Amsterdam', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).formatToParts(d);
      var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
      var asUtc = Date.UTC(+o.year, +o.month - 1, +o.day, +o.hour, +o.minute);
      return Math.round((asUtc - d.getTime()) / 60000);
    } catch (e) { return 60; }
  }
  function parseAms(str) {
    if (!str) return null;
    var m = String(str).trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!m) return null;
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
    var off = amsOffsetMin(new Date(guess));
    return guess - off * 60000;
  }
  function isLive() {
    if (!cfg.enabled) return false;
    var now = Date.now(), st = parseAms(cfg.start), en = parseAms(cfg.end);
    if (st && now < st) return false;
    if (en && now >= en) return false;
    return true;
  }
  var preview = /[?&]lm_bundel_test=1/.test(location.search);
  if (!isLive() && !preview) {
    if (cfg.offAuto && cfg.offRedirect) { location.replace(cfg.offRedirect); return; }
    var stt = parseAms(cfg.start), ot = $('[data-lm-bnd-offtitle]');
    if (cfg.enabled && stt && Date.now() < stt && ot && ot.getAttribute('data-soon')) ot.textContent = ot.getAttribute('data-soon');
    $('[data-lm-bnd-off]').hidden = false;
    return;
  }
  $('[data-lm-bnd-on]').hidden = false;

  /* ---------- helpers ---------- */
  var tiers = (cfg.tiers || []).filter(function (t) { return t && t.min > 0; }).sort(function (a, b) { return a.min - b.min; });
  if (!tiers.length) tiers = [{ min: 1, pct: 0 }];
  var sizes = String(cfg.sizes || 'XS,S,M,L,XL').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  var exclude = String(cfg.exclude || '').split(/\s+/).filter(Boolean);
  function money(c) {
    var v = (Math.round(c) / 100).toFixed(2).split('.');
    v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€ ' + v[0] + ',' + v[1];
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var EXTRA = cfg.calc === 'extra';
  function pctLabel(t) { return EXTRA ? (t.pct > 0 ? '+' + t.pct + '%' : 'sale') : t.pct + '%'; }
  function tierFor(n) { var t = null; tiers.forEach(function (x) { if (n >= x.min) t = x; }); return t; }
  function nextTier(n) { for (var i = 0; i < tiers.length; i++) if (tiers[i].min > n) return tiers[i]; return null; }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function post(url, body) {
    return fetch(shopRoot + url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); });
  }
  function thumb(u) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120' : ''; }
  function getJSON(url) { return fetch(url, { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); }

  var CATS = [
    { k: 'all', l: 'Alles' },
    { k: 'tops', l: 'Tops & blouses', t: ['Tops', 'T-shirts', 'Blouses'] },
    { k: 'broeken', l: 'Broeken', t: ['Trousers'] },
    { k: 'jassen', l: 'Blazers & jassen', t: ['Jackets & Blazers'] },
    { k: 'jurken', l: 'Jurken & rokken', t: ['Dresses', 'Skirts & Shorts', 'Jumpsuits & Playsuits'] },
    { k: 'truien', l: 'Truien & vesten', t: ['Sweaters & Cardigans'] },
    { k: 'look', l: 'Shop de look', look: true }
  ];
  function inCat(p, c) {
    if (c.k === 'all') return true;
    if (c.look) return p.tags.indexOf(cfg.lookTag) > -1;
    return c.t.indexOf(p.type) > -1;
  }

  /* ---------- state ---------- */
  var products = [], byHandle = {}, byVariant = {};
  var state = { size: store('lm_bnd_size') || '', cat: 'all', cart: [] };
  if (sizes.indexOf(state.size) < 0) state.size = '';

  /* ---------- hero treden ---------- */
  (function () {
    var ol = $('[data-lm-bnd-tiers]');
    if (!ol) return;
    if (cfg.showTiers === false) { ol.hidden = true; ol.innerHTML = ''; return; }
    ol.innerHTML = tiers.map(function (t, i) {
      var last = i === tiers.length - 1;
      var lab = t.min + (last && t.min > 1 ? '+' : '') + (t.min === 1 ? ' stuk' : ' stuks');
      return '<li><span>' + lab + '</span><strong>' + t.pct + '%</strong></li>';
    }).join('');
  })();

  /* ---------- kop v1.2: aanbod, aftelklok, knop ---------- */
  (function () {
    var off = $('[data-lm-bnd-offer]');
    if (off && EXTRA) {
      var paid = tiers.filter(function (t) { return t.pct > 0; });
      var baseTile = cfg.offerBase ? '<span class="lm-bnd__offer-i lm-bnd__offer-i--base"><b>' + esc(cfg.offerBaseLabel || 'Nu') + '</b><em>' + esc(cfg.offerBase) + '</em></span><span class="lm-bnd__offer-sep" aria-hidden="true"></span>' : '';
      if (paid.length) off.innerHTML = baseTile + paid.map(function (t, i) {
        var last = i === paid.length - 1;
        var lab = last && paid.length > 1 ? t.min + ' of meer' : t.min + ' stuks';
        return '<span class="lm-bnd__offer-i"><b>' + lab + '</b><em>' + t.pct + '% extra</em></span>';
      }).join('<span class="lm-bnd__offer-sep" aria-hidden="true"></span>');
    }
    var urg = $('[data-lm-bnd-urg]'), clock = $('[data-lm-bnd-clock]'), en = parseAms(cfg.end);
    if (urg && clock && en) {
      urg.hidden = false;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      (function tick() {
        var ms = Math.max(0, en - Date.now());
        var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4), sec = Math.floor(ms % 6e4 / 1e3);
        clock.innerHTML = [[d, d === 1 ? 'dag' : 'dagen'], [pad(h), 'uur'], [pad(m), 'min'], [pad(sec), 'sec']].map(function (x) { return '<span><b>' + x[0] + '</b><small>' + x[1] + '</small></span>'; }).join('');
        if (ms > 0) setTimeout(tick, 1000);
      })();
    }
    var cta = $('[data-lm-bnd-cta]');
    if (cta) cta.addEventListener('click', function (e) {
      e.preventDefault();
      var t = state.size ? $('[data-lm-bnd-bar]') : $('[data-lm-bnd-pick]');
      if (t) { var y = t.getBoundingClientRect().top + window.scrollY - ((document.querySelector('.header-wrapper, header') || {}).offsetHeight || 64) - 8; window.scrollTo({ top: y, behavior: 'smooth' }); }
    });
  })();
  function drawHero() {
    var box = $('[data-lm-bnd-heroimgs]');
    if (box && !box.children.length) {
      var hh = String(cfg.heroHandles || '').split(/\s+/).filter(Boolean);
      if (!hh.length) hh = String(cfg.featured || '').split(/\s+/).filter(Boolean);
      var pics = hh.map(function (h) { return byHandle[h]; }).filter(function (p) { return p && p.img; }).slice(0, 3);
      if (pics.length < 3) products.forEach(function (p) { if (pics.length < 3 && p.img && pics.indexOf(p) < 0) pics.push(p); });
      box.innerHTML = pics.map(function (p, i) { return '<img src="' + esc(p.img) + '" alt="" ' + (i ? 'loading="lazy"' : 'fetchpriority="high"') + ' width="600" height="800">'; }).join('');
      box.classList.add('is-ready');
    }
    var fr = $('[data-lm-bnd-from]');
    if (fr && cfg.scarcity && products.length) {
      var min = Infinity; products.forEach(function (p) { p.v.forEach(function (v) { if (v.a && v.p < min) min = v.p; }); });
      fr.textContent = cfg.scarcity.replace('[aantal]', products.length).replace('[vanaf]', money(min).replace(',00', ''));
    }
  }

  /* ---------- maatkeuze ---------- */
  function sizeButtons() {
    return sizes.map(function (z) { return '<button type="button" class="lm-bnd__size' + (z === state.size ? ' is-on' : '') + '" data-size="' + esc(z) + '" aria-pressed="' + (z === state.size) + '">' + esc(z) + '</button>'; }).join('');
  }
  function drawSizes() {
    $('[data-lm-bnd-sizes]').innerHTML = sizeButtons();
    $('[data-lm-bnd-sizes2]').innerHTML = sizeButtons();
    $('[data-lm-bnd-pick]').hidden = !!state.size;
    root.classList.toggle('has-size', !!state.size);
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-size]');
    if (!b) return;
    state.size = b.getAttribute('data-size');
    store('lm_bnd_size', state.size);
    drawSizes(); drawTabs(); drawGrid();
    var bar = $('[data-lm-bnd-bar]');
    if (b.closest('[data-lm-bnd-pick]') && bar) bar.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- categorieën ---------- */
  function variantFor(p) {
    for (var i = 0; i < p.v.length; i++) if (p.v[i].s === state.size && p.v[i].a) return p.v[i];
    return null;
  }
  function visible() {
    if (!state.size) return [];
    return products.filter(function (p) { return variantFor(p); });
  }
  function drawTabs() {
    var vis = visible();
    $('[data-lm-bnd-tabs]').innerHTML = CATS.map(function (c) {
      if (c.look && !cfg.lookTag) return '';
      var n = vis.filter(function (p) { return inCat(p, c); }).length;
      if (c.k !== 'all' && !n && state.size) return '';
      return '<button type="button" class="lm-bnd__tab' + (c.k === state.cat ? ' is-on' : '') + '" data-cat="' + c.k + '">' + c.l + (state.size ? ' <span>' + n + '</span>' : '') + '</button>';
    }).join('');
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cat]');
    if (!b) return;
    state.cat = b.getAttribute('data-cat');
    drawTabs(); drawGrid();
  });

  /* ---------- raster ---------- */
  function splitTitle(t) {
    var m = String(t).match(/^(.*?)\s+[|\-–]\s+(.*)$/);
    return m ? [m[1], m[2]] : [t, ''];
  }
  function qtyInCart(vid) {
    var q = 0; state.cart.forEach(function (l) { if (l.variant_id === vid) q += l.quantity; }); return q;
  }
  function priceHtml(pr, cmp) {
    if (cfg.showWas && cmp && cmp > pr) return '<s>' + money(cmp) + '</s> <strong>' + money(pr) + '</strong>';
    return money(pr);
  }
  function hint(pr) {
    if (!cfg.cardHint || !EXTRA) return '';
    var top = tiers[tiers.length - 1];
    if (!top || !top.pct) return '';
    var last = tiers.length > 1 && top.min > 1;
    return '<span class="lm-bnd__hint">' + top.min + (last ? '+' : '') + ' stuks: ' + money(Math.round(pr * (100 - top.pct) / 100)) + ' per stuk</span>';
  }
  function card(p) {
    var v = variantFor(p), tt = splitTitle(p.t), q = v ? qtyInCart(v.id) : 0;
    var img = p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.t) + '" loading="lazy" width="600" height="800">' : '';
    var img2 = p.img2 ? '<img class="lm-bnd__img2" src="' + esc(p.img2) + '" alt="" loading="lazy" width="600" height="800">' : '';
    var act = q > 0
      ? '<div class="lm-bnd__step"><button type="button" data-min="' + v.id + '" aria-label="Eén minder">−</button><span>' + q + '</span><button type="button" data-add="' + v.id + '" aria-label="Eén meer">+</button></div>'
      : '<button type="button" class="lm-bnd__add" data-add="' + v.id + '">Toevoegen</button>';
    var low = v && v.q > 0 && v.q <= 2 ? '<span class="lm-bnd__low">Nog ' + v.q + ' in ' + esc(state.size) + '</span>' : '';
    var szs = 0; p.v.forEach(function (x) { if (x.a) szs++; });
    var badge = (cfg.featBadge && p.feat < 9999) ? '<span class="lm-bnd__badge">' + esc(cfg.featBadge) + '</span>' : ((cfg.lastBadge && szs <= 2) ? '<span class="lm-bnd__badge lm-bnd__badge--last">' + esc(cfg.lastBadge) + '</span>' : '');
    var pc = (cfg.showWas && v && v.c > v.p) ? Math.round((1 - v.p / v.c) * 100) : 0;
    var pcb = pc ? '<span class="lm-bnd__pct">-' + pc + '%</span>' : '';
    return '<article class="lm-bnd__card' + (q ? ' is-in' : '') + '">' +
      '<a class="lm-bnd__media" href="' + esc(p.url) + '" target="_blank" rel="noopener">' + img + img2 + badge + pcb + '</a>' +
      '<div class="lm-bnd__info"><h3><a href="' + esc(p.url) + '" target="_blank" rel="noopener">' + esc(tt[0]) + '</a></h3>' +
      (tt[1] ? '<p class="lm-bnd__sub">' + esc(tt[1]) + '</p>' : '') +
      '<div class="lm-bnd__row"><span class="lm-bnd__price">' + priceHtml(v ? v.p : p.price, v ? v.c : p.cmp) + '</span>' + act + '</div>' + hint(v ? v.p : p.price) + low + '</div></article>';
  }
  function drawGrid() {
    var grid = $('[data-lm-bnd-grid]');
    if (!state.size) { grid.innerHTML = ''; $('[data-lm-bnd-empty]').hidden = true; return; }
    var cat = CATS.filter(function (c) { return c.k === state.cat; })[0] || CATS[0];
    var list = visible().filter(function (p) { return inCat(p, cat); });
    grid.innerHTML = list.map(card).join('');
    $('[data-lm-bnd-empty]').hidden = list.length > 0 || !products.length;
  }

  /* ---------- winkelwagen ---------- */
  function refreshDrawer() {
    return Promise.all([
      getJSON(shopRoot + 'cart.js'),
      fetch(shopRoot + '?sections=cart-drawer,cart-counter', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).catch(function () { return {}; })
    ]).then(function (r) {
      var cart = r[0]; cart.sections = r[1];
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.renderContents === 'function') { try { d.renderContents(cart, false); } catch (e) { /* drawer niet open: prima */ } }
      if (typeof window.updateCartCounters === 'function') window.updateCartCounters();
      var c = document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .header__cart-count');
      c.forEach(function (el) { el.textContent = cart.item_count; });
      setCart(cart);
    });
  }
  function setCart(cart) {
    state.cart = (cart.items || []).filter(function (l) { return byVariant[l.variant_id]; });
    state.cart.forEach(function (l) { if (!l.image) { var v = byVariant[l.variant_id]; l.image = v && v.prod ? v.prod.img : ''; } });
    drawPanel(); drawGrid();
  }
  /* acties in een wachtrij: snelle klikken gaan niet verloren */
  var queue = Promise.resolve();
  function enqueue(fn) { queue = queue.then(fn, fn); return queue; }
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-add]'), m = e.target.closest('[data-min]');
    if (!a && !m) return;
    e.preventDefault();
    var vid = +(a || m).getAttribute(a ? 'data-add' : 'data-min');
    var cardEl = (a || m).closest('.lm-bnd__card, .lm-bnd__line');
    if (cardEl) cardEl.classList.add('is-busy');
    enqueue(function () {
      var job = a ? post('cart/add.js', { items: [{ id: vid, quantity: 1 }] })
                  : post('cart/change.js', { id: String(vid), quantity: Math.max(0, qtyInCart(vid) - 1) });
      return job.then(refreshDrawer).catch(function (err) {
        var msg = (err && err.status === 422) || (err && /stock|voorraad|already/i.test(err.description || '')) ? 'Meer is er niet in deze maat.' : 'Dit lukte niet. Probeer het opnieuw.';
        flash(msg);
      }).then(function () { if (cardEl) cardEl.classList.remove('is-busy'); });
    });
  });
  root.addEventListener('click', function (e) {
    var r = e.target.closest('[data-del]');
    if (!r) return;
    e.preventDefault();
    var key = r.getAttribute('data-del');
    enqueue(function () { return post('cart/change.js', { id: key, quantity: 0 }).then(refreshDrawer).catch(function () {}); });
  });
  function flash(t) {
    var n = $('[data-lm-bnd-next]'); if (!n) return;
    n.textContent = t; n.classList.add('is-warn');
    setTimeout(function () { n.classList.remove('is-warn'); drawPanel(); }, 3500);
  }

  /* ---------- maat wijzigen in het paneel ---------- */
  var szOpen = '';
  function szPick(l) {
    if (szOpen !== l.key) return '';
    var v0 = byVariant[l.variant_id], p = v0 && v0.prod;
    if (!p || p.v.length < 2) return '<span class="lm-bnd__szpick"><em>Geen andere maten</em></span>';
    return '<span class="lm-bnd__szpick" role="group" aria-label="Kies een andere maat">' + p.v.map(function (v) {
      var cur = v.id === l.variant_id;
      return '<button type="button" class="lm-bnd__szopt' + (cur ? ' is-on' : '') + '"' + (cur || !v.a ? ' disabled' : '') + ' data-szto="' + v.id + '" data-szkey="' + esc(l.key) + '" data-szq="' + l.quantity + '">' + esc(v.s) + '</button>';
    }).join('') + '</span>';
  }
  root.addEventListener('click', function (e) {
    var o = e.target.closest('[data-szopen]');
    if (o) { e.preventDefault(); var k = o.getAttribute('data-szopen'); szOpen = szOpen === k ? '' : k; drawPanel(); return; }
    var t = e.target.closest('[data-szto]');
    if (!t || t.disabled) return;
    e.preventDefault();
    var nid = +t.getAttribute('data-szto'), key = t.getAttribute('data-szkey'), q = +t.getAttribute('data-szq') || 1;
    var li = t.closest('.lm-bnd__line'); if (li) li.classList.add('is-busy');
    enqueue(function () {
      return post('cart/add.js', { items: [{ id: nid, quantity: q }] })
        .then(function () { return post('cart/change.js', { id: key, quantity: 0 }); })
        .then(function () { szOpen = ''; return refreshDrawer(); })
        .catch(function () { flash('Deze maat is net op. Kies een andere maat.'); return refreshDrawer(); });
    });
  });

  /* ---------- paneel ---------- */
  function calc() {
    var n = 0, value = 0, adv = 0;
    state.cart.forEach(function (l) {
      var p = byVariant[l.variant_id];
      var cmp = p && p.c ? p.c : l.original_price;
      n += l.quantity; value += l.original_price * l.quantity; adv += cmp * l.quantity;
    });
    var t = tierFor(n), base = tiers[0];
    var total = value;
    if (t && n >= 2) {
      if (cfg.calc === 'extra') total = value * (100 - t.pct) / (100 - base.pct);
      else total = Math.min(value, adv * (100 - t.pct) / 100);
    }
    total = Math.round(total);
    return { n: n, value: value, adv: adv, total: total, save: value - total, tier: t, next: nextTier(n) };
  }
  function drawPanel() {
    var c = calc();
    var st = c.n === 1 ? '1 stuk' : c.n + ' stuks';
    $('[data-lm-bnd-count]').textContent = st;
    $('[data-lm-bnd-mcount]').textContent = st;
    /* vakjes */
    var maxSlots = Math.max(tiers[tiers.length - 1].min, 4), imgs = [];
    state.cart.forEach(function (l) { for (var i = 0; i < l.quantity; i++) imgs.push(l.image); });
    var slots = '';
    var nSlots = Math.min(6, Math.max(maxSlots, imgs.length));
    for (var i = 0; i < nSlots; i++) {
      var more = (i === nSlots - 1 && imgs.length > nSlots) ? imgs.length - nSlots + 1 : 0;
      slots += '<span class="lm-bnd__slot' + (imgs[i] ? ' is-full' : '') + '">' + (more ? '<b class="lm-bnd__more">+' + more + '</b>' : (imgs[i] ? '<img src="' + esc(thumb(imgs[i])) + '" alt="">' : '')) + '</span>';
    }
    $('[data-lm-bnd-slots]').innerHTML = slots;
    /* voortgang */
    var top = tiers[tiers.length - 1].min;
    $('[data-lm-bnd-fill]').style.width = Math.min(100, (c.n / top) * 100) + '%';
    $('[data-lm-bnd-steps]').innerHTML = tiers.map(function (t, i) {
      var last = i === tiers.length - 1;
      return '<li class="' + (c.n >= t.min ? 'is-on' : '') + '"><span>' + t.min + (last && t.min > 1 ? '+' : '') + '</span>' + pctLabel(t) + '</li>';
    }).join('');
    var nx = $('[data-lm-bnd-next]'), mtxt = '';
    if (!c.n) mtxt = 'Kies je eerste stuk';
    else if (c.next) { var d = c.next.min - c.n; mtxt = 'Nog ' + d + (d === 1 ? ' stuk' : ' stuks') + ' voor ' + c.next.pct + (EXTRA ? '% extra' : '% korting'); }
    else mtxt = EXTRA ? 'Je hebt de hoogste extra korting: ' + c.tier.pct + '%' : 'Je hebt de hoogste korting: ' + c.tier.pct + '%';
    if (!nx.classList.contains('is-warn')) nx.textContent = mtxt;
    $('[data-lm-bnd-mnext]').textContent = mtxt;
    /* regels */
    $('[data-lm-bnd-lines]').innerHTML = state.cart.map(function (l) {
      var tt = splitTitle(l.product_title);
      return '<li class="lm-bnd__line">' + (l.image ? '<img src="' + esc(thumb(l.image)) + '" alt="">' : '<span></span>') + '<div><strong>' + esc(tt[0]) + '</strong><span>Maat ' + esc(l.variant_options[l.variant_options.length - 1]) + (l.quantity > 1 ? ' · ' + l.quantity + 'x' : '') + '</span>' +
        '<span class="lm-bnd__lacts"><button type="button" data-szopen="' + esc(l.key) + '">Maat wijzigen</button><button type="button" data-del="' + esc(l.key) + '">Verwijderen</button></span>' + szPick(l) + '</div><b>' + money(l.original_line_price) + '</b></li>';
    }).join('');
    $('[data-lm-bnd-value]').textContent = money(c.value);
    $('[data-lm-bnd-save]').textContent = c.save > 0 ? '− ' + money(c.save) : money(0);
    root.querySelector('.lm-bnd__save').hidden = !(c.save > 0);
    $('[data-lm-bnd-total]').textContent = money(c.total);
    $('[data-lm-bnd-mtotal]').textContent = money(c.total);
    var sv = root.querySelector('.lm-bnd__saved'), saved = c.adv - c.total;
    if (sv) { sv.hidden = !(cfg.showWas && c.n && saved > 0); $('[data-lm-bnd-saved]').textContent = money(saved); }
    var go = $('[data-lm-bnd-go]');
    go.textContent = c.n ? 'Naar winkelwagen · ' + money(c.total) : 'Naar winkelwagen';
    go.classList.toggle('is-off', !c.n);
    /* drempels op het totaal na korting (alleen de bundel; overige artikelen tellen in de winkelwagen ook mee) */
    var thr = [];
    if (cfg.ship) thr.push(c.total >= cfg.ship ? '<li class="is-ok">Gratis verzending</li>' : '<li>Nog ' + money(cfg.ship - c.total) + ' tot gratis verzending</li>');
    if (cfg.gift) thr.push(c.total >= cfg.gift ? '<li class="is-ok">Je krijgt een ' + esc(cfg.giftName) + '</li>' : '<li>Nog ' + money(cfg.gift - c.total) + ' tot een ' + esc(cfg.giftName) + '</li>');
    $('[data-lm-bnd-thr]').innerHTML = c.n ? thr.join('') : '';
    root.classList.toggle('has-items', c.n > 0);
  }

  /* mobiel paneel open/dicht */
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-lm-bnd-open]')) { root.classList.add('panel-open'); document.documentElement.classList.add('lm-bnd-lock'); }
    if (e.target.closest('[data-lm-bnd-close]')) { root.classList.remove('panel-open'); document.documentElement.classList.remove('lm-bnd-lock'); }
  });

  /* ---------- data laden ---------- */
  function load(page, acc) {
    var u = cfg.dataUrl + '&page=' + page;
    var once = function () { return getJSON(u); };
    var retry = function () { return new Promise(function (ok) { setTimeout(ok, 1500); }).then(once); };
    return once().catch(retry).catch(retry).then(function (j) {
      acc = acc.concat(j.products || []);
      if (j.pages && page < j.pages && page < 8) return load(page + 1, acc);
      return acc;
    });
  }
  drawSizes(); drawTabs();
  Promise.all([load(1, []), getJSON(shopRoot + 'cart.js')]).then(function (r) {
    products = r[0].filter(function (p) { return exclude.indexOf(p.h) < 0; });
    products.forEach(function (p) {
      byHandle[p.h] = p;
      p.v.forEach(function (v) { byVariant[v.id] = v; v.prod = p; });
      var szs = 0, qty = 0;
      p.v.forEach(function (v) { if (v.a) szs++; qty += Math.max(0, v.q); });
      p.rank = szs * 1000 + Math.min(qty, 999);
    });
    var featured = String(cfg.featured || '').split(/\s+/).filter(Boolean);
    products.forEach(function (p) { var i = featured.indexOf(p.h); p.feat = i > -1 ? i : 9999; });
    products.sort(function (a, b) { return (a.feat - b.feat) || (b.rank - a.rank); });
    $('[data-lm-bnd-loading]').hidden = true;
    drawHero();
    drawTabs();
    setCart(r[1]);
  }).catch(function () {
    $('[data-lm-bnd-loading]').textContent = 'Laden lukte niet. Ververs de pagina.';
  });

  /* cart drawer elders aangepast: paneel bijwerken */
  document.addEventListener('visibilitychange', function () { if (!document.hidden) getJSON(shopRoot + 'cart.js').then(setCart).catch(function () {}); });
})();
